import { combineReducers } from "redux";

import loader from "./loaderReducer";
import environment from "./environmentReducer";
import user from "./userReducer";
import customers from "./customersReducer";
import vehicle from "./vehicleReducer";
import culture from "./cultureReducer";
const rootReducer = combineReducers({
	loader,
	environment,
	user,
	customers,
	vehicle,
	culture
});
export default rootReducer;
